import { ActionIcon, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "../icons";

// A button that does nothing when pressed, because a tooltip needs something focusable to hang off and there is
// nothing here to open; the sentence is the `aria-label` too, so what a pointer hovers for is what a screen reader
// reads. `touch` is named in the events because a tooltip nothing can hover is one half the readers never see.
export function InfoMark({ label }: { label: string }) {
  return (
    <Tooltip label={label} withArrow multiline w={260} events={{ hover: true, focus: true, touch: true }}>
      <ActionIcon variant="subtle" color="gray" size="md" aria-label={label}>
        <IconInfoCircle size="1.25rem" stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
